export {default} from './ForgotPasswordForm';



// WEBPACK FOOTER //
// ./src/containers/ForgotPasswordForm/index.ts